import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {
  updateLastAutoRecommendationAction,
  updateLastEditModeHelpTipAction,
} from '../../../../store/data/preferences/preferencesActions';
import {
  getLastAutoRecommendation,
  getLastEditModeHelpTip,
} from '../../../../store/data/preferences/preferencesSelectors';
import {getShouldRecommendDeclutter} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {startedEditingWorkspacesAction} from '../../../../store/panels/inboxes/inboxesPanelActions';
import {InboxesPanelId} from '../../../../store/panels/panelStateBase';
import {WorkspacesAutoRecBanner} from './workspacesAutoRecBanner';

interface WorkspacesAutoRecBannerContainerProps {
  panelId: InboxesPanelId;
}

const mapStateToProps = makeMapStateToProps<WorkspacesAutoRecBannerContainerProps>()(() => ({
  hasRarelyViewedItems: getShouldRecommendDeclutter,
  lastEditModeHelpTip: getLastEditModeHelpTip,
  lastAutoRecommendation: getLastAutoRecommendation,
}));

const mapDispatchToProps = makeMapDispatchToProps<WorkspacesAutoRecBannerContainerProps>()(({panelId}) => ({
  onEditWorkspaces: (hasRarelyViewedItems: boolean) =>
    startedEditingWorkspacesAction(panelId, hasRarelyViewedItems),
  updateLastAutoRecommendation: updateLastAutoRecommendationAction,
  updateLastEditModeHelpTip: updateLastEditModeHelpTipAction,
}));

export const WorkspacesAutoRecBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const {updateLastAutoRecommendation, updateLastEditModeHelpTip, onEditWorkspaces} = dispatchProps;
    const {hasRarelyViewedItems, lastEditModeHelpTip, lastAutoRecommendation} = stateProps;

    const onButtonClick = () => {
      if (lastEditModeHelpTip === undefined && lastAutoRecommendation) {
        updateLastEditModeHelpTip(lastAutoRecommendation);
      }
      updateLastAutoRecommendation(Date.now());
    };
    const onDismissClick = () => {
      onButtonClick();
    };

    const onShowMeClick = () => {
      onEditWorkspaces(hasRarelyViewedItems);
      onButtonClick();
    };

    return {
      ...ownProps,
      onDismissClick,
      onShowMeClick,
    };
  },
)(WorkspacesAutoRecBanner);
